import { Controller } from 'stimulus';

// The task form's Scheduling section (the new Schedule): the This / Any of
// These / none toggles show their panel and record the mode, Person's time
// follows the duration until someone picks one, and This Equipment rows are
// added, removed and set to Holds or Can Share. Every panel posts its inputs;
// Tasks::ScheduleInputs keeps the chosen mode's.
export default class extends Controller {
  static targets = ['duration', 'wholeTime', 'wholeSeg', 'wholeDefault', 'wholeReset', 'personMode', 'equipmentMode',
    'datesMode', 'anyShare', 'panel', 'rows', 'rowTemplate']

  pick(event) {
    const button = event.currentTarget;
    const { group, value } = button.dataset;
    this.press(button);
    if (group === 'whole') {
      this.wholeTimeTarget.value = value;
      this.wholeDefaultTarget.textContent = '';
      this.wholeResetTarget.hidden = false;
    } else if (group === 'anyshare') {
      this.anyShareTarget.value = value;
    } else {
      const modeTarget = { person: 'personModeTarget', equipment: 'equipmentModeTarget', dates: 'datesModeTarget' }[group];
      if (modeTarget) this[modeTarget].value = value;
      this.panelTargets.forEach((panel) => {
        const [panelGroup, panelValue] = panel.dataset.panel.split(':');
        if (panelGroup === group) panel.hidden = panelValue !== value;
      });
    }
  }

  // Back to the default for the duration: Whole time under 8 hours.
  useDefault() {
    this.wholeTimeTarget.value = '';
    this.wholeResetTarget.hidden = true;
    this.showDefault();
  }

  durationChanged() {
    if (this.wholeTimeTarget.value === '') this.showDefault();
  }

  showDefault() {
    const minutes = this.minutes(this.durationTarget.value);
    const whole = minutes > 0 && minutes < 480;
    const button = this.wholeSegTarget.querySelector(`[data-value="${whole}"]`);
    if (button) this.press(button);
    this.wholeDefaultTarget.textContent = `Default for this duration: ${whole ? 'Whole time' : 'Alongside'}.`;
  }

  // A close reading of what the server parses (ChronicDuration), enough to
  // show the default as someone types: "45 minutes", "1 h 10 min", "3 days".
  minutes(text) {
    const typed = (text || '').trim().toLowerCase();
    if (/^\d+$/.test(typed)) return parseInt(typed, 10);
    const units = { w: 10080, d: 1440, h: 60, m: 1 };
    let total = 0;
    typed.replace(/(\d+(?:\.\d+)?)\s*(w|d|h|m)[a-z]*/g, (_, n, unit) => { total += parseFloat(n) * units[unit]; return ''; });
    return Math.round(total);
  }

  addRow() {
    const row = this.rowTemplateTarget.content.firstElementChild.cloneNode(true);
    this.rowsTarget.appendChild(row);
    const select = row.querySelector('select');
    if (select) select.focus();
  }

  removeRow(event) {
    event.currentTarget.closest('.ts-row').remove();
  }

  rowShare(event) {
    const button = event.currentTarget;
    const row = button.closest('.ts-row');
    row.querySelector('[data-target="task-scheduling.rowShare"]').value = button.dataset.value;
    this.press(button);
  }

  press(button) {
    button.parentElement.querySelectorAll('button').forEach((b) => {
      const on = b === button;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on.toString());
    });
  }
}
